import { useDictionary } from "../../../../../../utilities/hooks/UseDictionary";
import pencil from '../../../../../../assets/icons/ic_pencil.svg';
import PropTypes from 'prop-types'
import useClientWidth from "../../../../../../utilities/hooks/useClientWidth";
import moment from "moment";

const CustomerDetails = ({details}) => {
    const dictionary = useDictionary();
    const clientWidth = useClientWidth();

    const displayDate = (date,isTime) => {
        if (!date) return '';
        const formattedDate = moment(date * 1000).format('MMM DD, YYYY');
        if (isTime) {
            const formattedTime = moment(date * 1000).format('HH:mm');
            return `${formattedDate} ${formattedTime}`;
        }
        return formattedDate;
    }

    return (
        <div
			className="booking-experience-details-container provider-customer-details"
		>
            <div
				className="settings-tab-bar"
				style={{
					justifyContent: 'space-between',
					backgroundColor: 'white',
					alignItems: 'center',
					borderTopLeftRadius: 12,
					borderTopRightRadius: 12
				}}
			>
				<div
					className="settings-tab"
					style={{ color: 'var(--brand-dark-blue)', cursor: 'initial' }}
				>
					{dictionary.details}
				</div>
			</div>
            <div className="booking-experience-details-content-container thin-scrollbar">
                <div className="participant-row-container" style={{ justifyContent: 'space-between' }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerEmail}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.email}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerPhoneNumber}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.phone ? details.phone : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerLastActivity}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.modified_at ? displayDate(details.modified_at,true) : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerCreateDate}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.created_at ? displayDate(details.created_at,true) : '-'}
                    </h4>
                </div>
            </div>
        </div>
    )
}

CustomerDetails.propTypes = {
    details: PropTypes.object
}
export default CustomerDetails;